import { useQuery } from '@tanstack/react-query'
import { useLocale } from '@/i18n/LocaleProvider'
import { getFreshness } from '@/lib/api'
import { formatDateTime } from '@/lib/format'

const FRESH_LABEL: Record<string, string> = {
  orders: 'fresh.orders',
  screenshots: 'fresh.screenshots',
  csv: 'fresh.csv',
  statements: 'fresh.statements',
}

export function Freshness() {
  const { t } = useLocale()
  const { data } = useQuery({
    queryKey: ['freshness'],
    queryFn: getFreshness,
    refetchInterval: 60_000,
  })

  if (!data) return null

  return (
    <div className="flex flex-nowrap items-center gap-2 text-xs md:flex-wrap md:gap-3">
      {data.sources.map((source) => (
        <span
          key={source.code}
          className={[
            'rounded-md border px-2 py-1',
            source.stale
              ? 'border-pending/30 text-pending'
              : 'border-surface-border text-slate-400',
          ].join(' ')}
          title={source.last_at ? formatDateTime(source.last_at) : t('fresh.none')}
        >
          {FRESH_LABEL[source.code] ? t(FRESH_LABEL[source.code] as string) : source.label}
          {source.last_at ? ` · ${formatDateTime(source.last_at)}` : ` · ${t('fresh.empty')}`}
        </span>
      ))}
    </div>
  )
}
